import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { getTourPassangers } from "services/reservation";

import Loader from "utilities/Loader";

import "./lists.scss";

export default function Lists() {
  const { type, id } = useParams();

  const [passangers, setPassangers] = useState([]);
  const [isBus, setIsBus] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadPage() {
      let res = await getTourPassangers(id);
      setPassangers(res.passangers);
      setIsBus(res.isBus);
      setLoading(false);
    }
    loadPage();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="the-lists-page d-flex justify-content-center">
        {passangers.length > 0 ? (
          <table>
            {type === "insurance" ? (
              <>
                <thead>
                  <td>#</td>
                  <td>نام و نام خانوادگی</td>
                  <td>کد ملی</td>
                  {isBus && <td>شماره صندلی</td>}
                  <td style={{ width: 200 }}>توضیحات</td>
                </thead>
                <tbody>
                  {passangers.map((passer, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{passer.fullname}</td>
                      <td>{passer.codemelli}</td>
                      {isBus && <td>{passer.seat_number}</td>}
                      <td></td>
                    </tr>
                  ))}
                </tbody>
              </>
            ) : type === "leader" ? (
              <>
                <thead>
                  <td>#</td>
                  <td>نام و نام خانوادگی</td>
                  <td>شماره همراه</td>
                  {isBus && <td>شماره صندلی</td>}
                  <td style={{ width: 200 }}>توضیحات</td>
                </thead>
                <tbody>
                  {passangers.map((passer, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{passer.fullname}</td>
                      <td>{passer.mobile}</td>
                      {isBus && <td>{passer.seat_number}</td>}
                      <td></td>
                    </tr>
                  ))}
                </tbody>
              </>
            ) : (
              ""
            )}
          </table>
        ) : (
          <h1>لیستی موجود نمیباشد. </h1>
        )}
      </div>
    </>
  );
}
